<svg
  class="line-chart"
  [class.line-chart--hide-deposits]="hideDepositsTransfers"
  [class.line-chart--hide-withdrawals]="hideWithdrawals"
></svg>
